import { AppDetailsPopover } from './AppDetailsPopover';
import { AppDisplay } from './AppDisplay';
import uniq from 'lodash/uniq';
import React, { useMemo } from 'react';
import { Space } from 'antd';
export const DirectionalAppList = ({ direction, ingestingAppIds, populatingAppIds }) => {
    const uniqueAppIds = useMemo(() => uniq(ingestingAppIds.concat(populatingAppIds)), [ingestingAppIds, populatingAppIds]);
    if (!uniqueAppIds.length) {
        return null;
    }
    return (React.createElement(Space, { align: 'start', direction: direction, size: direction === 'horizontal' ? 0 : 4 }, uniqueAppIds.map((appId) => React.createElement(AppDetailsPopover, { appId: appId, key: appId },
        React.createElement(AppDisplay, { appId: appId, key: appId, read: ingestingAppIds.includes(appId), write: populatingAppIds.includes(appId) })))));
};
